export default "__VITE_ASSET__DgUkwIxY__"